import React, { memo } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Box, Flex } from "@edricphan2022/uikit";
import { Text } from "@edricphan2022/uikit";
import LogoOrbit from "../LogoOrbit";
import FlexLayout from "../../components/LayoutFlex";
import SearchInput from "../../components/SearchInput";
import { ChevronRightIcon } from "@edricphan2022/uikit";
import Picture from "../../components/Picture";
import mediaQueries from "../../@uikit/theme/base";
import { useMatchBreakpoints } from "@edricphan2022/uikit";

import TeleIcon from "../../assets/Footer/Telegram.png";
import TwitterIcon from "../../assets/Footer/Twitter.png";
import YoutubeIcon from "../../assets/Footer/Youtube.png";
import MediumIcon from "../../assets/Footer/Medium.png";
import Bg from "../../assets/Home/Orbit.svg";

import Footer1 from "../../assets/Home/footer/footer1.png";
import Footer2 from "../../assets/Home/footer/footer2.png";
import Footer3 from "../../assets/Home/footer/footer3.png";
import FooterLogo from '../../assets/Home/FoooterLogo.svg';
import Arr from '../../assets/Footer/arrow.svg';

const ArrFooter = [
  {
    title: `Address`,
    desc: `Go Vap Dictrict,HoChiMinh City,`,
    desc1: `VietNam`,
  },
  {
    title: `Contact`,
    desc: `Tel.: +84 767 39 67 89`,
    desc1: `E-mail: admin@uniorbit.org`,
  },
  {
    title: `Follow`,
    desc: `Facebook`,
    desc1: `Twitter`,
    desc2: `LinkedIn`,
  },
];

const ArrIcon = [
  {
    title: `Socical`,
    list: [
      {
        src: TeleIcon,
      },
      {
        src: TwitterIcon,
      },
      {
        src: YoutubeIcon,
      },
      {
        src: MediumIcon,
      },
    ],
  },
];

const Footer: React.FC = () => {
  // const {isMobileL } = useMatchBreakpoints();

  const handleChange = () => {
    //
  };

  return (
    <Wrapper>
      <Container>
        <Logo>
          <img src={FooterLogo} alt="Footer Logo"/>
        </Logo>
        <FtElm>
          <FtFl1>
          {
            ArrFooter.map((item , index)=>{
              return(
              <TextElm key={index} >
                <h2>{item.title}</h2>
                <p>{item.desc}</p>
                <p>{item.desc1}</p>
                <p>{item.desc2}</p>
              </TextElm>)
            })
          }
          </FtFl1>
          <BoxInput>
            <h3>Subscribe news</h3>
            <Box>
              <input type="text" placeholder="Enter your email"/>
              <button></button>
            </Box>
          </BoxInput>
        </FtElm>
        <CopyRight>
          <h2>Copyright © Wikex Exchange development company 2018-2022</h2>
        </CopyRight>
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled(Box)`
  width: 100%;
  height: 100%;
  background: #333333;
  box-shadow: 0px 1px 12px 3px rgba(208, 214, 227, 0.25);
  position: relative;
  z-index: -1;
  overflow: hidden;
`;

const Container = styled(Box)`
    width: 100%;
    max-width: 1920px;
    padding: 0px 5.4vw;
    @media only screen and ( max-width: 1133px){
      padding: 0px 36px;
    }
    @media only screen and (max-width: 820px){
      padding: 0px 12px;
    }
`
const Logo = styled(Box)`
  width: 100%;
  margin-top: 73px;
  margin-bottom: 20px;
  p{
    color: #ffffff;
    font-weight: 500;
    font-size: 16px;
    font-family: ManropeRegular;
    letter-spacing: 0.155em;
    margin-bottom: 60px;
  }
  img{
    width: 100%;
    max-width: 200px;
  }
`
const FtElm = styled(Box)`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 56px;
  margin-bottom: 24px;
  position: relative;
  align-items: flex-start;
  :after {
    content: "";
    width: 80%;
    height: 1px;
    background-color: #fff;
    transform: translateX(-50%);
    position: absolute;
    bottom: 0px;
    left: 50%;
    opacity: 0.5;
  }
  @media only screen and (max-width: 1133px){
    flex-direction: column-reverse;
  }
  @media only screen and (max-width: 744px){
    flex-direction: column;
  }
`

const FtFl1 = styled(Box)`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 75%;
  @media only screen and (max-width: 1133px){
    width: 100%;
  }
  @media only screen and (max-width: 744px){
    flex-direction: column;
  }
`
const TextElm = styled(Box)`
  width: 30%;
  h2 , p{
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 4.2px;
    margin-bottom: 20px;
  }
  h2{
    text-transform: uppercase;
  }
  p{
    margin-bottom: 0px;
    letter-spacing: 0.5px;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
  }
  @media only screen and (max-width: 744px){
    flex-direction: column;
    margin-bottom: 25px;
    width: 100%;
    max-width: 415px;
    :last-child{
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      h2{
        width: 100%;
      }
      p{
        width: 33%;
      }
    }
  }
`;
const BoxInput = styled(Box)`
  width: 25%;
  h3{
    color: #ffffff;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 4.2px;
    text-transform: uppercase;
    margin-bottom: 20px;
  }
  div{
    width: 100%;
    display: flex;
    align-items: center;
    input{
      width: 100%;
      height: 40px;
      background: rgba(214, 214, 214, 0.1);
      max-width: 280px;
      border: none;
      outline: none;
      padding-left: 12px;
      color: #7C7C7C;
    }
    button{
      width: 40px;
      height: 40px;
      min-width: 40px;
      min-height: 40px;
      padding: 0px;
      margin: 0px;
      border: none;
      background-image: url('${Arr}');
      background-repeat: no-repeat;
      background-size: 40%;
      background-position: center center;
    }
  }
  @media only screen and (max-width: 1133px){
    margin-bottom: 45px;
    width: 50%;
  }
  @media only screen and (max-width: 744px){
    flex-direction: column;
    margin-top: 30px;
    margin-bottom: 0px;
    width: 100%;
    max-width: 430px;
    div{
      input{
        width: 100%;
        max-width: 100%;
      }
    }
  }
`
const CopyRight = styled(Box)`
  width: 100%;
  h2{
    color: #9F9FA0;
    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
    font-family: ManropeRegular;
    text-align: center;
  }
  margin-bottom: 35px;
  @media only screen and (max-width: 510px){
    width: 100%;
    max-width: 260px;
    margin: 0px auto 35px;
  }
`

export default memo(Footer);
